import { splitHexAlpha, tintStyles } from '../tint';

const getFilledStyles = (theme, color) => {
  if (!color || color === 'default') {
    return {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    };
  }
  if (color.startsWith('#')) {
    // "#rrggbbaa" is a tint: judging text by the solid color gave white on near-white
    const tint = splitHexAlpha(color);
    if (tint && tint.opacity < 0.7) return tintStyles(theme, tint.color, tint.opacity);
    return {
      backgroundColor: color,
      color: theme.palette.getContrastText(color),
    };
  }
  const palette = theme.palette[color];
  // `main`, not `dark`: the darkest shades (brown, maroon, deep red) looked muddy as chip fills
  return {
    backgroundColor: palette?.main ?? theme.palette.primary.main,
    color: palette?.contrastText ?? theme.palette.primary.contrastText,
  };
};

const getOutlinedStyles = (theme, color) => {
  if (!color || color === 'default') {
    return {
      border: `1px solid ${theme.palette.primary.main}90`,
      backgroundColor: `${theme.palette.primary.main}20`,
      color: theme.palette.primary.contrastTextDark,
    };
  }
  if (color.startsWith('#')) {
    const base = splitHexAlpha(color)?.color ?? color;
    return tintStyles(theme, base, 0.19);
  }
  const palette = theme.palette[color];
  return {
    border: `1px solid ${palette?.main ?? theme.palette.primary.main}90`,
    backgroundColor: `${palette?.light ?? theme.palette.primary.main}30`,
    color: palette?.contrastTextDark ?? palette?.contrastText,
  };
};

export const MuiChip = () => ({
  MuiChip: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius * 2,
        fontSize: "0.75rem",
        fontWeight: 500,
        height: "24px",
      }),
      filled: ({ theme, ownerState }) => getFilledStyles(theme, ownerState.color),
      outlined: ({ theme, ownerState }) => getOutlinedStyles(theme, ownerState.color),
      deleteIcon: ({ theme }) => ({
        color: theme.palette.text.secondary,
      }),
    },
  },
});
